import styled from "styled-components";

export const ToastrConfirmInput = styled.div`
  min-width: 300;
  display: flex;
  gap: 15px;
  flex-direction: column;
  margin-top: 15px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 10px;
  width: 100%;
`;